export default "/_next/static/f82aa5888f7d993365b55a2dbde3fbfb.jpg";